import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import PageNotFound from "./components/PageNotFound";
import Product from "./components/Product";
import Checkout from "./components/Checkout";
import Login from "./components/Login"
// import About from "./components/About";
// import Home from "./components/Home";
// import Navbar from "./components/Navbar";



// import ProductItem from "./components/ProductItem";

// import Payment from "./components/Payment";

// import {loadStripe} from '@stripe/stripe-js'
// import{Elements} from '@stripe/react-stripe-js'
// import Orders from "./components/Orders";
// const promise = loadStripe("pk_test_51Kckj5KDzmX0ctNw4OJV1heOHoGACh6Qr4EyZu8P3HOEUHY40UPYWEq1c7d6LPuytt9ecqKpgOQmrWmDDqSJuFL3006WAkyrdf")


function CustomRouter() {
  return (

    <Router>
      <Routes>

      <Route exact path='/' element={<div><Header/> <Product /></div>} />
      <Route exact path='/checkout' element={<div><Header/> <Checkout /></div>} />
      <Route exact path='/login' element={<div><Login /></div>} />
      <Route  path='*' element={<div> <Header/> <PageNotFound/></div>} />

      {/* <Route exact path='/Product' element={<div><Header/></div> } /> */}
      {/*
      <Route exact path='/orders' element={<div><Header/><Orders /></div>} />
      <Route exact path='/payment' element={<div><Header/><Elements stripe={promise}><Payment/> </Elements></div>} />

        <Route exact path='/Home' element={<div>Home page</div>} />
        <Route exact path='/About' element={<div>Navbar</div> } />

        <Route exact path='/ProductItem/:id' element={<div><Header/><ProductItem /></div> } />

        <Route  path='*' element={<div> <Header/><PageNotFound/></div>} /> */}

      </Routes>
    </Router>
  );
}

export default CustomRouter;
